import { defineStore } from "pinia";
import type { ReducedPlace } from "~/interfaces/publisher";
import BasketService from "~/services/BasketService";

export const useBasketStore = defineStore("basketStore", () => {
  const nuxtApp = useNuxtApp();
  const basket = ref<ReducedPlace[]>([]);
  const isDraft = ref<boolean>(false);
  const draftId = ref<number>(0);
  const orders = ref<any[]>([]);
  // Модалка корзины живёт в MainBusket, но открывают её и из других мест
  // (панель канала в каталоге), поэтому флаг держим в сторе
  const isBasketDialogOpen = ref<boolean>(false);

  // Название рекламной кампании. В новом дизайне задаётся на шаге «Корзина»
  // и переносится дальше по флоу создания заказа.
  const campaignName = ref<string>("");

  const getCampaignName = () => {
    if (import.meta.client) {
      campaignName.value = localStorage.getItem("campaignName") || "";
    }
    return campaignName.value;
  };

  watch(campaignName, (newName) => {
    if (import.meta.client) localStorage.setItem("campaignName", newName);
  });

  const setDraftId = (id: number) => {
    localStorage.setItem("draftId", id.toString());
    draftId.value = id;
  };

  const getDraftId = () => {
    draftId.value = localStorage.getItem("draftId") ? Number(localStorage.getItem("draftId")) : 0;
    return draftId.value;
  };

  const getDraftStatus = () => {
    isDraft.value = localStorage.getItem("isDraft")
      ? localStorage.getItem("isDraft") === "true"
      : false;
    return isDraft.value;
  };

  const setDraftStatus = (status: boolean) => {
    localStorage.setItem("isDraft", status.toString());
    isDraft.value = status;
  };

  watch(
    basket,
    (newBasket) => {
      // ВАЖНО: на SSR-страницах (/s/**) гидрация Pinia заменяет basket пустым
      // серверным значением до чтения localStorage — пропускаем эту запись,
      // иначе сохранённая корзина затирается «{"places":[]}».
      if (nuxtApp.isHydrating) return;
      BasketService.setBasket({ places: newBasket as any });
    },
    { deep: true }
  );

  return {
    basket,
    isDraft,
    draftId,
    orders,
    isBasketDialogOpen,
    campaignName,
    getCampaignName,
    setDraftId,
    getDraftId,
    getDraftStatus,
    setDraftStatus,
  };
});
